/* tslint:disable */
/* eslint-disable */
/**
 * Web App core API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * The user needs to send the token for invitation accept
 * @export
 * @interface InvitationAcceptBody
 */
export interface InvitationAcceptBody {
    /**
     * 
     * @type {string}
     * @memberof InvitationAcceptBody
     */
    token: string;
}

/**
 * Check if a given object implements the InvitationAcceptBody interface.
 */
export function instanceOfInvitationAcceptBody(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "token" in value;

    return isInstance;
}

export function InvitationAcceptBodyFromJSON(json: any): InvitationAcceptBody {
    return InvitationAcceptBodyFromJSONTyped(json, false);
}

export function InvitationAcceptBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): InvitationAcceptBody {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'token': json['token'],
    };
}

export function InvitationAcceptBodyToJSON(value?: InvitationAcceptBody | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'token': value.token,
    };
}

